import decode from "jwt-decode";

interface User {
  email: string;
  role: string;
}

export function getUser(): User {
  const token = localStorage.getItem(String(process.env.REACT_APP_LOCAL_KEY));

  if (!token) {
    throw new Error("Error");
  }

  const user: User = decode(token);

  return user;
}
